import { Component, Input, OnInit } from '@angular/core';
import { CustomerTodoListComponent } from '../../todo/CustomerTodoList/CustomerTodoList.component';
import { wobbleIf } from '../../../shared/animations';

@Component({
	selector: 'app-components-managecustomer-floatingcustomertodolist',
  templateUrl: './FloatingCustomerTodoList.component.html',
  animations: [wobbleIf]
})
export class FloatingCustomerTodoListComponent implements OnInit {
  @Input() customer: Boo.Objects.Customer;
  todoListPanel: IJQueryFloatPanel;
  unresolved = 0;
  unsavedChanges = false;
  ctlViewModel: CustomerTodoListComponent;

  ngOnInit() {
    this.todoListPanel = ($('#customer-todo-list-float-panel') as any).floatPanel({ collapsed: true });
  }

  save(): void {
    this.ctlViewModel.save();
  }

  customerTodoListComposeBinding(model: CustomerTodoListComponent): void {
    this.ctlViewModel = model;

    // number of unresolved todos
    this.unresolved = this.ctlViewModel.unresolvedTodos();
    this.ctlViewModel.unresolvedTodos.subscribe(x => this.unresolved = x);

    // change detection
    this.ctlViewModel.unsavedChanges.subscribe(x => this.unsavedChanges = x);
  }
}
